import React from 'react';

const Contact = () => (
  <div>

    <p>
      Should you have any questions about Direct Hedge or the services we provide please don't hesitate to contact us:
    </p>
    <p>
      Direct Hedge Danmark<br />
      Fondsmæglerselskab A/S<br />
      Fuglevangsvej 11<br />
      1962 Frederiksberg C - Denmark<br />
    </p>
    <p>
      CVR no.: 33 24 90 63
    </p>
    <p>
      Regulated by the Danish Financial Supervisory Authority
    </p>
    <p>
      Phone: +45 7020 1297
    </p>
    <p>
      <b>Relevant E-mails:</b><br />
      Fertilizer Brokering Desk:	<a href="mailto:fertilizer@directhedge.com">fertilizer@directhedge.com</a><br />
      Edible Oils Brokering Desk:	<a href="mailto:oliveoil@directhedge.com">oliveoil@directhedge.com</a><br />
      Salmon Brokering Desk:	<a href="mailto:salmon@directhedge.com">salmon@directhedge.com</a><br />
      General:	<a href="mailto:info@directhedge.com">info@directhedge.com</a><br />
    </p>

    <p>
      <b>Associated offices</b><br />
      <u>North America</u><br />
      Direct Hedge rep office<br />
      701 S. Howard Ave. Ste. 205<br />
      Tampa, FL 33606<br />
      USA<br />
      Phone: +1 813-448-7575<br />
      Email: <a href="mailto:fertilizer@directhedge.com">fertilizer@directhedge.com</a><br />
    </p>

    <p>
      <u>Spain</u><br />
      Direct Hedge Rep. Office<br />
      Calle Granado Del Higuerón 4 - 4A<br />
      29640, Fuengirola (Málaga), Spain.<br />
      Phone +34 952 378 852<br />
      Email: <a href="mailto:fertilizer@directhedge.com">fertilizer@directhedge.com</a><br />
    </p>
  </div>
);

export default Contact;



// WEBPACK FOOTER //
// ./source/screens/static/Contact.js